module.exports = __webpack_public_path__ + "img/myBoard1.1b854df5.png";